import React, { useState, useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useAxios from 'axios-hooks';
import logo_footer from '../../images/Logo_footer.svg';
import ageIcon from '../../images/footer-icon-18+.svg';
import upster from '../../images/footer-upster-logo.svg';
import './Footer.scss';
import { GeneralContext } from '../../context/generalContext';
import { getBaseUrl } from '../../functions/getBaseUrl';
import ReserveBtn from '../SideButtons/ReserveBtn';
import DeliveryBtn from '../SideButtons/DeliveryBtn';
import ModalAddresses from './ModalAdresses/ModalAddresses';
import { addressesAPI } from '../../services/GeneralService';
import { addressesLinkHadle } from '../../functions/functions';
import VkBtn from './VkBtn/VkBtn';
import InstagramBtn from './InstagramBtn/InstagramBtn';

function Footer() {
  const {
    activeMenuItem,
    subdomain,
    subdomainIsActive,
    selectedAddress,
    cities,
    activeCity,
    detectWidth,
    windowWidth,
    activeLanguage,
    setActiveMenuItem,
    currentCityAddress,
  } = useContext(GeneralContext);
  const { data: addresses } = addressesAPI.useFetchAllAddressesQuery();
  const [showModal, setShowModal] = useState(false);
  const [addressesAll, setAddressesAll] = useState([]);

  const [{ data }] = useAxios({
    url: `${getBaseUrl()}/api/articles?page=1&perPage=8`,
    method: 'GET',
    options: {
      params: {
        articlesPerPage: 8,
        offset: 0,
      },
    },
    trigger: 1,
    articlesPerPage: 8,
  });

  useEffect(() => {
    let arr = [];
    if (addresses) {
      arr = addressesLinkHadle(addresses);

      setAddressesAll(arr);
    }
  }, [subdomain, addresses]);

  useEffect(() => {
    window.addEventListener('resize', detectWidth);
    return () => {
      window.removeEventListener('resize', detectWidth);
    };
  });

  const [footerCity, setFooterCity] = useState(1);
  const onShowModal = cityId => {
    setShowModal(true);
    setFooterCity(cityId);
  };

  const goToTop = () => {
    window.scrollTo({
      top: 0,
    });
    setActiveMenuItem();
  };

  // заморозить область за модальным если оно открыто
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = 'visible';
      document.body.style.position = '';
      document.body.style.width = '';
    }
  }, [showModal]);

  const currentYear = new Date().getFullYear();
  // скрываем футер на странице скачивания приложения
  const { pathname } = useLocation();
  if (pathname === '/club-app' || pathname === '/en/club-app') return null;

  return (
    <footer className='footer'>
      <div className='d-flex jc-space-between footer-container'>
        <div className='footer_wrapper'>
          <div className='gridContainer'>
            <div className='logoBlock'>
              <div className='logoFooter'>
                <img
                  className='logo'
                  src={
                    subdomainIsActive
                      ? addresses?.filter(address => address.id === selectedAddress)[0]?.logo_footer || logo_footer
                      : logo_footer
                  }
                  alt='logo footer'
                />
                <img src={ageIcon} alt='18+ icon' className='footer-age-iccon' />
              </div>
            </div>
            <div className='citiesBlock'>
              {subdomainIsActive ? (
                <a
                  href={
                    window.location.hostname.split('.')[window.location.hostname.split('.').length - 2] ===
                      'keep-calm' || subdomain === 'test'
                      ? 'https://lambic.keep-calm.ru/'
                      : 'https://lambic.ru/'
                  }
                  className='addressTitle'
                >
                  {activeLanguage === 1 ? 'Пивные рестораны' : 'Beer restaurants'}
                </a>
              ) : (
                <div className='addressTitle'>{activeLanguage === 1 ? 'Пивные рестораны' : 'Beer restaurants'}</div>
              )}
              <div className='cities-list'>
                {cities.map(city => (
                  <div className='button city' onClick={() => onShowModal(city.id)} key={city.id}>
                    {activeLanguage === 1 ? city.name : city.name_en || city.name}
                  </div>
                ))}
              </div>
            </div>
            <div className='infoBlock'>
              {currentCityAddress?.tel && (
                <a href={`tel:${currentCityAddress.tel}`} className='phone'>
                  {currentCityAddress.telModified}
                </a>
              )}
              <a href={`mailto:${cities.filter(city => city.id === activeCity)[0]?.email}`} className='email'>
                {cities.filter(city => city.id === activeCity)[0]?.email || ''}
              </a>
            </div>
            <div className='buttonsBlock'>
              <Link
                to={activeLanguage === 1 ? '/feedback' : '/en/feedback'}
                className='button grid-1'
                onClick={goToTop}
              >
                {activeLanguage === 1 ? 'ОСТАВИТЬ ОТЗЫВ' : 'REPORT US'}
              </Link>
              <Link
                to={activeLanguage === 1 ? '/franchise' : '/en/franchise'}
                className={data?.total > 0 ? 'button grid-4' : 'button grid-7'}
                onClick={goToTop}
              >
                {activeLanguage === 1 ? 'ФРАНШИЗА' : 'FRANCHISE APPLICATION'}
              </Link>
              <Link to={activeLanguage === 1 ? '/sitemap' : '/en/sitemap'} className='button grid-2' onClick={goToTop}>
                {activeLanguage === 1 ? 'КАРТА САЙТА' : 'SITE MAP'}
              </Link>
              {data?.total > 0 && (
                <Link
                  to={activeLanguage === 1 ? '/articles' : '/en/articles'}
                  className='button grid-3'
                  onClick={goToTop}
                >
                  {activeLanguage === 1 ? 'СТАТЬИ' : 'ARTICLES'}
                </Link>
              )}

              {activeCity === 6 && (
                <>
                  <Link
                    to={activeLanguage === 1 ? '/privacy-policy' : '/en/privacy-policy'}
                    className='button grid-5'
                    onClick={goToTop}
                  >
                    {activeLanguage === 1 ? 'ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ' : 'PRIVACY POLICY'}
                  </Link>
                  <div className='double-btns grid-6'>
                    <InstagramBtn />
                    <VkBtn />
                  </div>
                </>
              )}
              {activeCity !== 6 && (
                <div className='double-btns grid-5'>
                  <Link
                    to={activeLanguage === 1 ? '/privacy-policy' : '/en/privacy-policy'}
                    className='button privacy'
                    onClick={goToTop}
                  >
                    {activeLanguage === 1 ? 'ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ' : 'PRIVACY POLICY'}
                  </Link>
                  <VkBtn />
                </div>
              )}
            </div>
            <div className='upsterBlock'>
              <a href='https://upster.ru/'>
                <img className='upster' src={upster} alt='upster' />
              </a>
              <div className='company'>
                {activeLanguage === 1 ? (
                  <span>
                    Управляющая
                    <br />
                    компания{' '}
                  </span>
                ) : (
                  <span>
                    Managing
                    <br />
                    company{' '}
                  </span>
                )}
                <span className='companyName'>Upster</span>
              </div>
            </div>
            <div className='rightsBlock'>
              {activeLanguage === 1 ? `© ${currentYear} Права защищены` : `© ${currentYear} All rights reserved`}
            </div>
          </div>
        </div>
      </div>

      <ModalAddresses
        showModal={showModal}
        setShowModal={setShowModal}
        addressesAll={addressesAll}
        footerCity={footerCity}
        setFooterCity={setFooterCity}
      />
      {windowWidth > 915 ? (
        <div className='footer-fixed-btns'>
          {activeMenuItem !== 3 && <ReserveBtn isMobile={false} />}
          <DeliveryBtn isMobile={false} />
        </div>
      ) : (
        <>
          {activeMenuItem !== 3 && (
            <div className='footer-fixed-btns-mobile'>
              <ReserveBtn isMobile />
              <DeliveryBtn isMobile />
            </div>
          )}
        </>
      )}
    </footer>
  );
}

export default Footer;
